/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Comos-managed browser configuration, requiring its MPS solution.
 */
export type ComosManagedWhatsAppOnboardingConfigurationResponse = {
    /**
     * Durable attempt identifier required when signup completes.
     */
    attemptId: string;
    /**
     * Comos-managed billing snapshotted for this attempt.
     */
    billingMode: ComosManagedWhatsAppOnboardingConfigurationResponse.billingMode;
    /**
     * Tenant policy revision snapshotted for this attempt.
     */
    policyRevision: number;
    solutionId: string;
};
export namespace ComosManagedWhatsAppOnboardingConfigurationResponse {
    /**
     * Comos-managed billing snapshotted for this attempt.
     */
    export enum billingMode {
        COMOS_MANAGED = 'comos_managed',
    }
}

